import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const CaretRight: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 16 16" {...props}>
    <polygon
      transform="translate(8.000000, 8.000000) rotate(-90.000000) translate(-8.000000, -8.000000) "
      points="0 4.36450579 7.99946869 11.6354942 16 4.36450579"
    ></polygon>
  </Icon>
);
